import moment from "moment";

export const getReturnDate = (eventDateValue, rentalTerm = "1 week") => {
    const eventDate = moment.utc(eventDateValue);

    if (!eventDate.isValid()) return "";

    const currentDay = eventDate.isoWeekday(); // 1 = Monday ... 7 = Sunday

    let weekendDate;

    if (currentDay === 7) {
        // Sunday → Previous Saturday
        weekendDate = eventDate.clone().subtract(1, "day");
    } else if (currentDay === 1) {
        // Monday → Previous Saturday
        weekendDate = eventDate.clone().subtract(2, "days");
    } else if (currentDay === 6) {
        // Saturday → Current Saturday
        weekendDate = eventDate.clone();
    } else {
        // Tuesday to Friday → Upcoming Saturday
        weekendDate = eventDate.clone().isoWeekday(6);
    }

    const weeks = parseInt(rentalTerm) || 1;

    // Tuesday after weekend + extra weeks
    return weekendDate
        .clone()
        .add((weeks - 1) * 7 + 3, "days")
        .format("MMM D, YYYY");
};


export const getReturnWeeks = (eventDate, rentalTerm = "1 week") => {
    const returnDate = getReturnDate(eventDate, rentalTerm);
    if (!returnDate) return "Not Late";

    const today = moment().startOf("day");
    const returnMoment = moment(returnDate).startOf("day");

    // Friday of return date week
    const fridayOfReturnWeek = returnMoment.clone().isoWeekday(5);

    // Before Friday = not late
    if (today.isBefore(fridayOfReturnWeek)) {
        return "Not Late";
    }

    // Friday itself = 1 Week Late
    const diffWeeks = today.diff(fridayOfReturnWeek, "weeks") + 1;

    return `${diffWeeks} Week${diffWeeks > 1 ? "s" : ""} Late`;
};